import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, Tab, Tabs } from '@mui/material';

import { getThingToken } from 'api/devices';
import Card from 'components/Card';
import Field from 'components/Field';
import ThingDevices from 'components/ThingDevices';
import Translator from 'utils/enumTranslator';

import ObjectDescriptors from '../components/ObjectDescriptors';

import 'Modals/modals.scss';
import './styles.scss';

const tabStyle = {
  border: 'none',
  color: '#d0d4d6',
  fontSize: 16,
  fontWeight: 600,
  textTransform: 'none',
  '&.Mui-selected': {
    color: '#6d8994',
    backgroundColor: '#f7f7f7',
  },
};

const ThingDetail = ({ object }) => {
  const { cusID: customerUUID, ecoID: ecosystemUUID } = useParams();
  const [token, setToken] = useState(object.token);
  const [selectedTab, setSelectedTab] = useState(1);

  useEffect(() => {
    const getToken = async () => {
      getThingToken({ customerUUID, ecosystemUUID, uuid: object.uuid })
        .then((response) => {
          if (response.token) {
            setToken(response.token);
          }
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error('Error fetching thing token:', error);
        });
    };
    if (object?.uuid && !object.token) {
      getToken();
    }
  }, [customerUUID, ecosystemUUID, object]);

  const renderConfig = () => {
    const category = Translator.category(object.category);
    const profileGroup = object.profileGroup || 'Unknown group';

    return (
      <div className="modal__content padded new-thing-survey">
        <Card header={false}>
          <div className="thing__details">
            <div className="thing__name-type">
              <div className="form-row">
                <Field.Group extraClass="thing-uuid" testId="thing-uuid">
                  <Field.Text copy text={object.uuid} />
                  <Field.Text extraClass="object-name" text={object.name} title={object.name} />
                </Field.Group>
              </div>
              <div className="form-row">
                <Field.Group label="Category / Type" testId="thing-category">
                  <Field.Text text={`${category.label} / Thing`} />
                </Field.Group>
              </div>
            </div>
            <div className="thing__options">
              <Field.Group label="Profile Group" testId="thing-profile_group">
                <Field.Text text={profileGroup.name} />
              </Field.Group>
              <Field.Group label="Operational Importance" testId="thing-asset_value">
                <Field.Text text={object.assetValue} />
              </Field.Group>
              <Field.Group label="Configuration Options" testId="thing-config_options">
                <ThingDevices data={object} token={token} />
                <p className="thing__contribute">
                  {'Device not listed? '}
                  <span>Contribute your configuration</span>
                </p>
              </Field.Group>
            </div>
          </div>
        </Card>
      </div>
    );
  };

  return (
    <Box id="object__tabs">
      <Tabs
        value={selectedTab}
        onChange={(_, value) => setSelectedTab(value)}
        sx={{
          border: 'none',
          px: { xs: 2, md: 5 },
          pt: 2,
          '& .MuiTabs-indicator': {
            backgroundColor: '#11AEFB',
          },
        }}
      >
        <Tab value={1} label="Configuration" className="object__tab" sx={tabStyle} />
        <Tab value={2} label="Descriptors" className="object__tab" sx={tabStyle} />
      </Tabs>
      {selectedTab === 1 && renderConfig()}
      {selectedTab === 2 && <ObjectDescriptors object={object} />}
    </Box>
  );
};

ThingDetail.propTypes = {
  object: PropTypes.object.isRequired,
};

export default ThingDetail;
